/* ==========================================================================
   Ozeret -- screen registry
   One place mapping a view name to its component and its app-bar title.
   ========================================================================== */

import type { ComponentType } from 'react';
import type { ScreenName } from '../store';

import { WorkFeed } from './cleaner/WorkFeed';
import { JobDetail } from './cleaner/JobDetail';
import { Calendar, EditWeek } from './cleaner/Calendar';
import { JobInProgress } from './cleaner/JobInProgress';
import {
  CleanerBookingDetail, CleanerBookings, HouseBookingDetail,
} from './shared/Bookings';
import {
  EditCleanerProfile, MyCleanerProfile, OtherCleanerProfile,
} from './shared/CleanerProfile';
import { FindCleaner } from './house/FindCleaner';
import { EditRequest, PostRequest } from './house/PostRequest';
import { PastJob, RequestDetail, Requests } from './house/Requests';
import { EditHome, HouseProfile, JobList } from './house/HouseProfile';
import {
  CleanerChat, CleanerMessages, HouseChat, HouseMessages,
} from './shared/Messages';
import {
  FeedbackScreen, Notifications, ReviewScreen, Settings,
} from './shared/Misc';
import { Admin } from './shared/Admin';
import { Sql } from './shared/Sql';

export const TITLES: Record<ScreenName, string> = {
  c_jobs: 't_findwork',
  c_job: 't_thejob',
  c_calendar: 't_mycalendar',
  c_editweek: 't_mycalendar',
  c_bookings: 't_myjobs',
  c_booking: 't_booking',
  c_messages: 't_messages',
  c_chat: '',
  c_profile: 't_myprofile',
  c_editprofile: 't_editprofile',
  c_inprogress: 't_inprogress',
  h_find: 't_findcleaner',
  h_cleaner: 't_profile',
  h_post: 't_whatneed',
  h_editrequest: 't_editrequest',
  h_requests: 't_myrequests',
  h_request: 't_applicants',
  h_joblist: 't_myjoblist',
  h_booking: 't_booking',
  h_messages: 't_messages',
  h_chat: '',
  h_profile: 't_myhome',
  h_edithome: 't_myhome',
  h_pastjob: 't_pastjob',
  notifications: 't_updates',
  review: 't_review',
  feedback: 't_feedback',
  settings: 't_settings',
  admin: 't_admin',
  sql: 't_sql',
};

export const SCREENS: Record<ScreenName, ComponentType> = {
  c_jobs: WorkFeed,
  c_job: JobDetail,
  c_calendar: Calendar,
  c_editweek: EditWeek,
  c_bookings: CleanerBookings,
  c_booking: CleanerBookingDetail,
  c_messages: CleanerMessages,
  c_chat: CleanerChat,
  c_profile: MyCleanerProfile,
  c_editprofile: EditCleanerProfile,
  c_inprogress: JobInProgress,
  h_find: FindCleaner,
  h_cleaner: OtherCleanerProfile,
  h_post: PostRequest,
  h_editrequest: EditRequest,
  h_requests: Requests,
  h_request: RequestDetail,
  h_joblist: JobList,
  h_booking: HouseBookingDetail,
  h_messages: HouseMessages,
  h_chat: HouseChat,
  h_profile: HouseProfile,
  h_edithome: EditHome,
  h_pastjob: PastJob,
  notifications: Notifications,
  review: ReviewScreen,
  feedback: FeedbackScreen,
  settings: Settings,
  admin: Admin,
  sql: Sql,
};
